module.exports = __webpack_public_path__ + "img/toefl.52188a25.jpg";